module.exports = __webpack_public_path__ + "img/home.2cdcb5fc.svg";